export const onJobStatusChanged = `
  subscription OnJobStatusChanged($tenantId: String!, $username: String!, $jobType: JobType!) {
    onJobStatusChanged(tenantId: $tenantId, username: $username, jobType: $jobType) {
      jobId
      name
      tenantId
      username
      cognitoSub
      jobType
      status
      documentProcessingStatus
      documentVerificationStatus
      investorGuidelineReviewStatus
      loanCount
      processedLoanCount
      failedLoanCount
      verifiedDocumentCount
      totalDocumentCount
      guidelineCheckCount
      totalGuidelineCount
      uploadLocation
      exportLocation
      createdAt
      startedAt
      completedAt
    }
  }
`;

export const onLoanStatusChanged = `
  subscription OnLoanStatusChanged($jobId: ID!, $tenantId: String!) {
    onLoanStatusChanged(jobId: $jobId, tenantId: $tenantId) {
      loanId
      jobId
      tenantId
      username
      cognitoSub
      loanNumber
      borrowerName
      propertyAddress
      fileCount
      status
      createdAt
      startedAt
      completedAt
      processedFileCount
      failedFileCount
    }
  }
`;

export const onFileStatusChanged = `
  subscription OnFileStatusChanged($loanId: ID!, $jobId: ID!, $tenantId: String!) {
    onFileStatusChanged(loanId: $loanId, jobId: $jobId, tenantId: $tenantId) {
      fileId
      loanId
      jobId
      tenantId
      username
      cognitoSub
      filename
      fileSize
      s3Key
      status
      pageCount
      splitDocumentCount
      invocationId
      createdAt
      processedAt
      errorMessage
    }
  }
`;

export const onDocumentStatusChanged = `
  subscription OnDocumentStatusChanged($loanId: ID!, $jobId: ID!, $tenantId: String!) {
    onDocumentStatusChanged(loanId: $loanId, jobId: $jobId, tenantId: $tenantId) {
      documentId
      fileId
      loanId
      jobId
      tenantId
      username
      cognitoSub
      sourceFilename
      pageRange
      documentType
      confidenceScore
      requiresHumanReview
      processedDataS3Key
      createdAt
      processedAt
      reviewTaskARN
      errorMessage
    }
  }
`;
